<template>
  <div>
    <admin-form-item title="옵션 추가/수정" :useTab="false">
      <div v-if="section===1">
        <admin-form-item label="옵션 템플릿 선택">
          <span class="select">
            <select @change="selectOptionTemplate">
               <option value="" disabled selected>옵션 템플릿 선택</option>
               <option v-for="(option,idx) in optionTemplateArr"
                       :key="'option-'+idx"
                       :value="option.value">{{ option.label }}</option>
            </select>
          </span>
        </admin-form-item>
      </div>
      <div v-if="section===2">
        <div class="columns is-multiline">
          <div class="column is-full">
            <admin-form-item label="옵션 선택">
              <div>{{ product_selector.name }}</div>
            </admin-form-item>
          </div>
          <div class="column is-7">
            <admin-form-item label="옵션명*">
              <input class="input"
                     :value="product_selector.name"
                     @input="e => product_selector.name = e.target.value"
                     type="text" maxlength="30">
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="옵션 종류">
              <lp-radio @onSelect="setOptionType"
                        value_name="value"
                        label_name="label"
                        :val.sync="product_selector.option_type"
                        :data="optionType"
                        :block="true"></lp-radio>
            </admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="상품옵션 기본값 여부">
              <div class="flex align-center">
                <lp-check-bool :checked-val.sync="product_selector.required"
                               label="상품 등록 시 기본 옵션으로 설정되게 합니다"></lp-check-bool>
                <button class="button small is-grey-light" style="margin-left: 12px; cursor:unset">유료</button>
              </div>
            </admin-form-item>
          </div>
          <div class="column is-full">
            <div class="columns is-multiline"
                 style="border:1px solid #e5e5e5;margin-bottom:18px"
                 v-for="(option,idx) in product_selector.options"
                 :key="'option-'+idx"
                 v-if="product_selector.options.length>0">
              <div class="column is-6">
                <admin-form-item label="옵션값">
                  <input class="input"
                         :value="option.name"
                         @input="e => option.name = e.target.value"
                         type="text" maxlength="20">
                </admin-form-item>
              </div>
              <div class="column is-6">
                <admin-form-item label="옵션가격">
                  <div class="flex">
                    <input class="input"
                           :value="option.price"
                           @input="e => option.price = e.target.value"
                           type="number" maxlength="20">
                    <div class="flex space-between align-center">
                      <div style="margin-left:3px">원</div>
                      <i class="material-icons"
                         @click="deleteOptionValue(idx)"
                         style="line-height: 32px;margin-left:12px">close</i>
                    </div>
                  </div>
                </admin-form-item>
              </div>
              <!-- 입고 수량 -->
              <div class="column is-6">
                <admin-form-item label="입고 수">
                  <input class="input"
                         v-model="option.input"
                         @input="e => option.input = e.target.value"
                         type="number">
                </admin-form-item>
              </div>
              <!-- 재고 수량 -->
              <div class="column is-6">
                <admin-form-item label="재고 수">
                  {{ option.stock }}개
                </admin-form-item>
              </div>
              <div v-if="package==='download'"
                   class="columns is-multiline"
                   style="margin: 0">
                <div class="column is-6">
                  <admin-form-item label="옵션 설명">
                    <textarea class="textarea"
                              rows="4"
                              cols="4"
                              v-model="option.desc"></textarea>
                  </admin-form-item>
                </div>
                <div class="column is-6">
                  <admin-form-item label="옵션 파일">
                    <input type="file"
                           @input="onUploadFile($event, option)">
                  </admin-form-item>
                </div>
                <div class="column is-6">
                  <admin-form-item label="다운로드 기간">
                    <input class="input"
                           :value="option.download_period"
                           @input="e => option.download_period = e.target.value"
                           type="number" maxlength="365">
                  </admin-form-item>
                </div>
                <div class="column is-6">
                  <admin-form-item label="다운로드 횟수">
                    <input class="input"
                           :value="option.download_count"
                           @input="e => option.download_count = e.target.value"
                           type="number" maxlength="1000000">
                  </admin-form-item>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <button class="button is-grey" @click="addOptionValue">옵션값 추가</button>
          </div>
          <div class="lp-border-line"></div>
          <div class="column">
            <button class="button is-primary" @click="saveData">추가하기</button>
          </div>
        </div>
      </div>
    </admin-form-item>
  </div>
</template>

<script>

  import AdminFormItem from "../admin/AdminFormItem";
  import LpCheckBool from "../common/LpCheckBool";
  import LpRadio from "../common/LpRadio";

  export default {
    props: ['data'],
    components: {
      LpCheckBool,
      AdminFormItem,
      LpRadio
    },
    data() {
      return {
        section:1,
        product_selector: {

        },
        optionTemplateArr:[
          { label: '새 옵션 추가', value: 0 }
        ],
        optionTypeoptionType: [
          { label: '상품속성옵션', value:0, detail:'*상품 주문 시 반드시 선택해야 하는 상품 속성 성격의 옵션입니다.'},
          { label: '추가옵션', value:1, detail:'*상품 주문 시 추가 주문할 수 있는 성격의 옵션입니다.'}
        ],
        type: [],
        package: ''
      }
    },
    computed: {
    },
    created() {
      this.getSelector();
      if(this.data.id>0){
        this.section = 2;
      }
      this.product_selector = this.data;
      // 커머스 팩이 다운로드 팩일 경우에 따라 필드 사용 여부가 달라짐
      this.package = this.data.commercePack;

    },
    watch: {
      data(n) {
        if(n.id>0){
          this.section = 2;
        }
        else {
          this.section = 1;
        }
        this.product_selector = n;
        this.package = this.data.commercePackage;
      },
      modalStatus(n){
        /*if(n==='cancel'){
          this.section = 1;
        }*/
      }
    },
    methods: {
      getPackages() {
        this.packages = this.$store.getters.getPackages;
      },
      // 옵션 종류 선택
      setOptionType(res){
        this.product_selector.option_type = res.value;
      },
      addOptionValue(){
        this.product_selector.options.push({name: '옵션', price: 0});
      },
      deleteOptionValue(index){
        removeIndex(this.product_selector.options, index);
      },
      // 옵션 템플릿 선택
      selectOptionTemplate(e){
        if(e.target.value==0) {
          this.product_selector = {
            id:0,
            name:'',
            type:0,
            selected: true,
            required: false,
            option_type: 0,
            options: [
              {name: '옵션', price: 0, input: 0, stock: 0},
              {name: '옵션', price: 0, input: 0, stock: 0}
            ]
          }
        }
        else {
          for(let i=0; i<this.optionTemplateArr.length; i++) {
            if(this.optionTemplateArr[i].id==e.target.value){
              this.product_selector = this.optionTemplateArr[i];
              this.product_selector.id = 0;
              break;
            }
          }
        }
        this.section = 2;
      },
      getSelector(){
        this.$axios.get(this.getUrl('product/selector')).then(res=>{
          let selectors = this.optionTemplateArr.concat(res.data);
          selectors.forEach(selector=>{
            // 기본 추가 옵션 제
            if(selector.value>0) {
              selector.options.forEach(option => {
                option.stock = 0;
                option.input = 0;
              })
            }
          })
          this.optionTemplateArr = selectors;
        })
      },
      // 데이터 추가하기
      saveData(){
        if(!this.product_selector.name) {
          this.toast('옵션명을 입력하세요.');
          return;
        }
        this.$store.commit('closeModal', this.product_selector);
        //this.section = 1;
      },
      onUploadFile(evt, option) {
        console.log(evt.target);
        let formData = new FormData();
        formData.append('f', evt.target.files[0])
        this.$axios.post('admin/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
          .then(res => {
            console.log('uploaded');
            option.files = res.data.url;
          });
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>

</style>
